import { type PlanDetails } from './plan-catalog.ts'

export function planFeatureLines(plan: PlanDetails): string[] {
	return [
		limitLabel(plan.tanks, 'tank', 'tanks'),
		plan.parameterLogsPerMonth < 0
			? 'Unlimited parameter logs'
			: `${plan.parameterLogsPerMonth} parameter logs a month`,
		plan.coralAnalysesPerMonth < 0
			? 'Unlimited coral analyses'
			: `${plan.coralAnalysesPerMonth} coral analyses a month`,
		plan.galleryImagesPerTank < 0
			? 'Unlimited gallery photos per tank'
			: `${plan.galleryImagesPerTank} gallery photos per tank`,
	]
}

function limitLabel(count: number, singular: string, plural: string) {
	if (count < 0) return `Unlimited ${plural}`
	const noun = count === 1 ? singular : plural
	return `${count} ${noun}`
}

/** Price line used on the subscription settings page. */
export function formatSettingsPrice(monthly: number) {
	if (monthly === 0) return '$0'
	return `$${monthly.toFixed(2)}/mo`
}

export function formatMonthlyAmount(monthly: number) {
	if (monthly === 0) return '$0'
	return `$${monthly.toFixed(2)}`
}

export function formatYearlyAmount(yearly: number) {
	if (yearly <= 0) return null
	return `$${yearly.toFixed(2)}/year`
}
